import { Quicklink } from 'models';

const preConfiguredQuicklinks: Record<string, Quicklink[]> = {
  abritel: [
    {
      label: 'abritel-home',
      title: 'Abritel FR Homepage',
      text: 'Trouvez la location de vacances de vos rêves sur Abritel',
      url: 'https://www.abritel.fr/',
    },
    {
      label: 'france',
      title: 'France',
      text: 'Trouvez des locations de vacances en France sur Abritel',
      url: 'https://www.abritel.fr/d/33814/france',
    },
    {
      label: 'normandie',
      title: 'Normandie',
      text: 'Trouvez des locations de vacances en Normandie sur Abritel',
      url: 'https://www.abritel.fr/d/24796/normandie',
    },
    {
      label: 'bretagne',
      title: 'Bretagne',
      text: 'Trouvez des locations de vacances en Bretagne sur Abritel',
      url: 'https://www.abritel.fr/d/44887/bretagne',
    },
    {
      label: 'corse',
      title: 'Corse',
      text: 'Trouvez des locations de vacances en Corse sur Abritel',
      url: 'https://www.abritel.fr/d/20806/corse',
    },
    {
      label: 'maison-avec-piscine',
      title: 'Locations de vacances avec piscine',
      text: 'Trouver des locations de vacances avec piscine sur Abritel',
      url: 'https://www.abritel.fr/sejours/maison-avec-piscine',
    },
    {
      label: 'maison-avec-jacuzzi',
      title: 'Maisons avec jacuzzi',
      text: 'Trouver des locations de vacances avec jacuzzi sur Abritel',
      url: 'https://www.abritel.fr/sejours/maison-avec-jacuzzi',
    },
    {
      label: 'gorges-du-verdon',
      title: 'Gorges du Verdon',
      text: 'Trouver des locations de vacances Gorges du Verdon sur Abritel',
      url: 'https://www.abritel.fr/d/347883/gorges-du-verdon',
    },
    {
      label: 'provence-alpes-cote-dazur',
      title: "Provence-Alpes-Côte d'Azur",
      text: "Trouvez des locations de vacances en Provence-Alpes-Côte d'Azur sur Abritel",
      url: 'https://www.abritel.fr/d/5648/provence-alpes-cote-dazur',
    },
    {
      label: 'ile-de-re',
      title: 'Île de Ré',
      text: "Trouvez des locations de vacances sur l'île de Ré sur Abritel",
      url: 'https://www.abritel.fr/d/3239/ile-de-re',
    },
  ],
  'au-hcom': [
    {
      label: 'hcom-home',
      title: 'Hotels.com Australia Homepage',
      text: 'Find your dream accommodation on Hotels.com',
      url: 'https://au.hotels.com/',
    },
    {
      label: 'sydney',
      title: 'Sydney',
      text: 'Find Sydney accommodation on Hotels.com',
      url: 'https://au.hotels.com/de26633/accommodation-sydney-new-south-wales',
    },
    {
      label: 'gold-coast',
      title: 'Gold Coast',
      text: 'Find Gold Coast accommodation on Hotels.com',
      url: 'https://au.hotels.com/de23616/accommodation-gold-coast-queensland',
    },
    {
      label: 'melbourne',
      title: 'Melbourne',
      text: 'Find Melbourne accommodation on Hotels.com',
      url: 'https://au.hotels.com/de1633621/accommodation-melbourne-victoria',
    },
    {
      label: 'brisbane',
      title: 'Brisbane',
      text: 'Find Brisbane accommodation on Hotels.com',
      url: 'https://au.hotels.com/de1633623/accommodation-brisbane-queensland',
    },
    {
      label: 'canberra',
      title: 'Canberra',
      text: 'Find Canberra accommodation on Hotels.com',
      url: 'https://au.hotels.com/de1633564/accommodation-canberra-australian-capital-territory',
    },
    {
      label: 'adelaide',
      title: 'Adelaide',
      text: 'Find Adelaide accommodation on Hotels.com',
      url: 'https://au.hotels.com/de1633558/accommodation-adelaide-south-australia',
    },
    {
      label: 'sunshine-coast',
      title: 'Sunshine Coast',
      text: 'Find Sunshine Coast accommodation on Hotels.com',
      url: 'https://au.hotels.com/de1641908/hotels-sunshine-coast-queensland',
    },
    {
      label: 'cairns',
      title: 'Cairns',
      text: 'Find Cairns accommodation on Hotels.com',
      url: 'https://au.hotels.com/de11117194/hotels-cairns-and-vicinity-queensland',
    },
    {
      label: 'last-minute-deals',
      title: 'Last minute deals',
      text: 'Find last minute hotel deals on Hotels.com',
      url: 'https://au.hotels.com/hotel-deals/last-minute-hotel-deals',
    },
  ],
  'au-stayz': [
    {
      label: 'stayz-home',
      title: 'Stayz AU Homepage',
      text: 'Find your dream vacation rental on Stayz',
      url: 'https://www.stayz.com.au/',
    },
    {
      label: 'australia',
      title: 'Australia',
      text: 'Find Australia vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/d/11278/australia',
    },
    {
      label: 'gold-coast',
      title: 'Gold Coast',
      text: 'Find Gold Coast vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/d/48329/gold-coast',
    },
    {
      label: 'new-south-wales',
      title: 'New South Wales',
      text: 'Find New South Wales vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/travel/campaign/meso-dnsw',
    },
    {
      label: 'sunshine-coast',
      title: 'Sunshine Coast',
      text: 'Find Sunshine Coast vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/d/777/sunshine-coast',
    },
    {
      label: 'sydney',
      title: 'Sydney',
      text: 'Find Sydney vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/d/404865/sydney',
    },
    {
      label: 'pet-friendly',
      title: 'Pet Friendly',
      text: 'Find Pet Friendly vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/travel/pet-friendly',
    },
    {
      label: 'party-houses',
      title: 'Party Houses',
      text: 'Find Party Houses vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/d/737450/party-house',
    },
    {
      label: 'mornington-peninsula',
      title: 'Mornington Peninsula',
      text: 'Find Mornington Peninsula vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/d/16726/mornington-peninsula',
    },
    {
      label: 'victoria',
      title: 'Victoria',
      text: 'Find Victoria vacation rentals on Stayz',
      url: 'https://www.stayz.com.au/d/14199/victoria',
    },
  ],
  'ca-hcom': [
    {
      label: 'hcom-home',
      title: 'Hotels.com Canada Homepage',
      text: 'Find your dream accommodation on Hotels.com',
      url: 'https://ca.hotels.com/',
    },
    {
      label: 'vancouver',
      title: 'Vancouver',
      text: 'Find Vancouver accommodation on Hotels.com',
      url: 'https://ca.hotels.com/de169712/vancouver-british-columbia-hotels-rooms',
    },
    {
      label: 'banff',
      title: 'Banff',
      text: 'Find Banff accommodation on Hotels.com',
      url: 'https://ca.hotels.com/de170124/banff-alberta-hotels-rooms',
    },
    {
      label: 'toronto',
      title: 'Toronto',
      text: 'Find Toronto accommodation on Hotels.com',
      url: 'https://ca.hotels.com/de1636865/toronto-ontario-hotels-rooms',
    },
    {
      label: 'edmonton',
      title: 'Edmonton',
      text: 'Find Edmonton accommodation on Hotels.com',
      url: 'https://ca.hotels.com/de167228/edmonton-alberta-hotels-rooms',
    },
    {
      label: 'okanagan-valley',
      title: 'Okanagan Valley',
      text: 'Find Okanagan Valley accommodation on Hotels.com',
      url: 'https://ca.hotels.com/re1643884/hotels-in-okanagan-valley-canada',
    },
    {
      label: 'calgary',
      title: 'Calgary',
      text: 'Find Calgary accommodation on Hotels.com',
      url: 'https://ca.hotels.com/de169003/calgary-alberta-hotels-rooms',
    },
    {
      label: 'montreal',
      title: 'Montreal',
      text: 'Find Montreal accommodation on Hotels.com',
      url: 'https://ca.hotels.com/de169716/montreal-quebec-hotels-rooms',
    },
    {
      label: 'free-cancellation-deals',
      title: 'Free cancellation deals',
      text: 'Find free cancellation deals on Hotels.com',
      url: 'https://ca.hotels.com/hotel-deals/freecanc',
    },
    {
      label: 'budget-friendly-deals',
      title: 'Budget-friendly deals',
      text: 'Find budget-friendly deals on Hotels.com',
      url: 'https://ca.hotels.com/hotel-deals/budgetfriendly',
    },
  ],
  'ca-vrbo': [
    {
      label: 'vrbo-home',
      title: 'Vrbo CA Homepage',
      text: 'Find your dream vacation rental on Vrbo',
      url: 'https://www.vrbo.com/en-ca/',
    },
    {
      label: 'canada',
      title: 'Canada',
      text: 'Find Canada vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/canada',
    },
    {
      label: 'ontario',
      title: 'Ontario',
      text: 'Find Ontario vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/ontario',
    },
    {
      label: 'kelowna',
      title: 'Kelowna',
      text: 'Find Kelowna vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/british-columbia/central-okanagan/kelowna',
    },
    {
      label: 'british-columbia',
      title: 'British Columbia',
      text: 'Find British Columbia vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/british-columbia',
    },
    {
      label: 'maui',
      title: 'Maui',
      text: 'Find Maui vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/united-states/hawaii/maui',
    },
    {
      label: 'canmore',
      title: 'Canmore',
      text: 'Find Canmore vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/alberta/canmore',
    },
    {
      label: 'vancouver',
      title: 'Vancouver',
      text: 'Find Vancouver vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/british-columbia/greater-vancouver/vancouver',
    },
    {
      label: 'florida',
      title: 'Florida',
      text: 'Find Florida vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/united-states/florida',
    },
    {
      label: 'prince-edward-island',
      title: 'Prince Edward Island',
      text: 'Find Prince Edward Island vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/prince-edward-island',
    },
  ],
  'fewo-direkt': [
    {
      label: 'fewodirekt-home',
      title: 'FeWo-direkt DE Homepage',
      text: 'Finden Sie Ihre Traumferienwohnung auf FeWo-direkt',
      url: 'https://www.fewo-direkt.de/',
    },
    {
      label: 'ostsee',
      title: 'Ostsee',
      text: 'Ostsee-Ferienwohnungen finden auf FeWo-direkt',
      url: 'https://www.fewo-direkt.de/d/287117/ostsee',
    },
    {
      label: 'nordsee',
      title: 'Nordsee',
      text: 'Nordsee-Ferienwohnungen auf FeWo-direkt finden',
      url: 'https://www.fewo-direkt.de/d/276604/nordsee',
    },
    {
      label: 'deutschland',
      title: 'Deutschland',
      text: 'Ferienwohnungen in Deutschland auf FeWo-direkt finden',
      url: 'https://www.fewo-direkt.de/d/30695/deutschland',
    },
    {
      label: 'gardasee',
      title: 'Gardasee',
      text: 'Ferienwohnungen am Gardasee finden auf FeWo-direkt',
      url: 'https://www.fewo-direkt.de/d/91340/gardasee',
    },
    {
      label: 'bodensee',
      title: 'Bodensee',
      text: 'Ferienwohnungen Bodensee auf FeWo-direkt finden',
      url: 'https://www.fewo-direkt.de/d/58868/bodensee',
    },
    {
      label: 'allgau',
      title: 'Allgäu',
      text: 'Ferienwohnungen im Allgäu auf FeWo-direkt finden',
      url: 'https://www.fewo-direkt.de/d/49644/allgau',
    },
    {
      label: 'eibsee',
      title: 'Eibsee',
      text: 'Eibsee-Ferienwohnungen auf FeWo-direkt finden',
      url: 'https://www.fewo-direkt.de/d/73436/eibsee',
    },
    {
      label: 'whirpool',
      title: 'Feriendomizile mit Whirlpool',
      text: 'Ferienhäuser mit Whirlpool auf FeWo-direkt finden',
      url: 'https://www.fewo-direkt.de/reisen/whirlpool',
    },
    {
      label: 'norddeich',
      title: 'Norddeich',
      text: 'Ferienwohnungen Norddeich auf FeWo-direkt finden',
      url: 'https://www.fewo-direkt.de/d/34258/norddeich',
    },
  ],
  'uk-hcom': [
    {
      label: 'hcom-home',
      title: 'Hotels.com UK Homepage',
      text: 'Find your dream accommodation on Hotels.com',
      url: 'https://uk.hotels.com/',
    },
    {
      label: 'london',
      title: 'London',
      text: 'Find London accommodation on Hotels.com',
      url: 'https://uk.hotels.com/de549499/hotels-london-united-kingdom',
    },
    {
      label: 'dubai',
      title: 'Dubai',
      text: 'Find Dubai accommodation on Hotels.com',
      url: 'https://uk.hotels.com/de11594/hotels-dubai-united-arab-emirates',
    },
    {
      label: 'manchester',
      title: 'Manchester',
      text: 'Find Manchester accommodation on Hotels.com',
      url: 'https://uk.hotels.com/de544578/hotels-manchester-united-kingdom',
    },
    {
      label: 'devon',
      title: 'Devon',
      text: 'Find Devon accommodation on Hotels.com',
      url: 'https://uk.hotels.com/de1641724/hotels-devon-county-united-kingdom',
    },
    {
      label: 'hampshire',
      title: 'Hampshire',
      text: 'Find Hampshire accommodation on Hotels.com',
      url: 'https://uk.hotels.com/de1641735/hotels-hampshire-county-united-kingdom',
    },
    {
      label: 'yorkshire',
      title: 'Yorkshire',
      text: 'Find Yorkshire accommodation on Hotels.com',
      url: 'https://uk.hotels.com/re10248460/hotels-in-yorkshire-united-kingdom',
    },
    {
      label: 'edinburgh',
      title: 'Edinburgh',
      text: 'Find Edinburgh accommodation on Hotels.com',
      url: 'https://uk.hotels.com/de554344/hotels-edinburgh-united-kingdom',
    },
    {
      label: 'free-cancellation-deals',
      title: 'Free cancellation deals',
      text: 'Find free cancellation deals on Hotels.com',
      url: 'https://uk.hotels.com/hotel-deals/freecanc',
    },
    {
      label: 'budget-friendly-deals',
      title: 'Budget-friendly deals',
      text: 'Find budget-friendly deals on Hotels.com',
      url: 'https://uk.hotels.com/hotel-deals/budgetfriendly',
    },
  ],
  'uk-vrbo': [
    {
      label: 'vrbo-home',
      title: 'Vrbo UK Homepage',
      text: 'Find your dream vacation rental on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom',
    },
    {
      label: 'england',
      title: 'England',
      text: 'Find England vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england',
    },
    {
      label: 'spain',
      title: 'Spain',
      text: 'Find Spain vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/spain',
    },
    {
      label: 'scotland',
      title: 'Scotland',
      text: 'Find Scotland vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/scotland',
    },
    {
      label: 'hot-tub-breaks',
      title: 'Hot tub breaks',
      text: 'Find Hot tub breaks on Vrbo',
      url: 'https://www.vrbo.com/en-gb/travel/hot-tub-breaks',
    },
    {
      label: 'cornwall',
      title: 'Cornwall',
      text: 'Find Cornwall vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england/cornwall',
    },
    {
      label: 'france',
      title: 'France',
      text: 'Find France vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/france',
    },
    {
      label: 'london',
      title: 'London',
      text: 'Find London vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england/greater-london/london',
    },
    {
      label: 'wales',
      title: 'Wales',
      text: 'Find Wales vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/wales',
    },
    {
      label: 'florida',
      title: 'Florida',
      text: 'Find Florida vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/en-gb/holiday-rentals/united-states/florida',
    },
  ],
  'us-expedia': [
    {
      label: 'expedia-home',
      title: 'Expedia USA Homepage',
      text: 'Plan and book your whole trip on Expedia',
      url: 'https://www.expedia.com/',
    },
    {
      label: 'stays',
      title: 'Stays',
      text: 'Find places to stay on Expedia',
      url: 'https://www.expedia.com/Hotels',
    },
    {
      label: 'flights',
      title: 'Flights',
      text: 'Find the right flight for your trip on Expedia',
      url: 'https://www.expedia.com/Flights',
    },
    {
      label: 'packages',
      title: 'Packages',
      text: 'Find your dream vacation package on Expedia',
      url: 'https://www.expedia.com/Vacation-Packages',
    },
    {
      label: 'cars',
      title: 'Cars',
      text: 'Find car rental and airport transport deals on Expedia',
      url: 'https://www.expedia.com/Cars',
    },
    {
      label: 'activities',
      title: 'Activities',
      text: 'Find fun activities for your trip on Expedia',
      url: 'https://www.expedia.com/Activities',
    },
    {
      label: 'cruise',
      title: 'Cruise',
      text: 'Find your dream cruise on Expedia',
      url: 'https://www.expedia.com/Cruises',
    },
    {
      label: 'las-vegas',
      title: 'Las Vegas',
      text: 'Find places to stay in Las Vegas on Expedia',
      url: 'https://www.expedia.com/Las-Vegas-Hotels.d178276.Travel-Guide-Hotels',
    },
    {
      label: 'orlando',
      title: 'Orlando',
      text: 'Find places to stay in Orlando on Expedia',
      url: 'https://www.expedia.com/Orlando-Hotels.d178294.Travel-Guide-Hotels',
    },
    {
      label: 'miami',
      title: 'Miami',
      text: 'Find places to stay in Miami on Expedia',
      url: 'https://www.expedia.com/Miami-Hotels.d178286.Travel-Guide-Hotels',
    },
    {
      label: 'cancun',
      title: 'Cancun',
      text: 'Find places to stay in Cancun on Expedia',
      url: 'https://www.expedia.com/Cancun-Hotels.d179995.Travel-Guide-Hotels',
    },
    {
      label: 'los-angeles',
      title: 'Los Angeles',
      text: 'Find places to stay in Los Angeles on Expedia',
      url: 'https://www.expedia.com/Los-Angeles-Hotels.d178280.Travel-Guide-Hotels',
    },
  ],
  'us-hcom': [
    {
      label: 'hcom-home',
      title: 'Hotels.com USA Homepage',
      text: 'Find your dream accommodation on Hotels.com',
      url: 'https://www.hotels.com/',
    },
    {
      label: 'las-vegas',
      title: 'Las Vegas',
      text: 'Find Las Vegas accommodations on Hotels.com',
      url: 'https://www.hotels.com/de1504033/hotels-las-vegas-nevada',
    },
    {
      label: 'orlando',
      title: 'Orlando',
      text: 'Find Orlando accommodations on Hotels.com',
      url: 'https://www.hotels.com/de1404711/hotels-orlando-florida',
    },
    {
      label: 'los-angeles',
      title: 'Los Angeles',
      text: 'Find Los Angeles accommodations on Hotels.com',
      url: 'https://www.hotels.com/de1439028/hotels-los-angeles-california',
    },
    {
      label: 'miami',
      title: 'Miami',
      text: 'Find Miami accommodations on Hotels.com',
      url: 'https://www.hotels.com/de1516192/hotels-miami-florida',
    },
    {
      label: 'san-diego',
      title: 'San Diego',
      text: 'Find San Diego accommodations on Hotels.com',
      url: 'https://www.hotels.com/de1483250/hotels-san-diego-california',
    },
    {
      label: 'dallas',
      title: 'Dallas',
      text: 'Find Dallas accommodations on Hotels.com',
      url: 'https://www.hotels.com/de1486134/hotels-dallas-texas',
    },
    {
      label: 'road-trips',
      title: 'Road trips',
      text: 'Find great American road trips on Hotels.com',
      url: 'https://www.hotels.com/page/roadtrips',
    },
    {
      label: 'nature-deals',
      title: 'Nature deals',
      text: 'Save on your next trip to the great outdoors on Hotels.com',
      url: 'https://www.hotels.com/hotel-deals/nature',
    },
    {
      label: 'budget-friendly-deals',
      title: 'Budget-friendly deals',
      text: 'Find budget-friendly deals on Hotels.com',
      url: 'https://www.hotels.com/hotel-deals/budgetfriendly',
    },
  ],
  'us-vrbo': [
    {
      label: 'vrbo-home',
      title: 'Vrbo US Homepage',
      text: 'Find your dream vacation rental on Vrbo',
      url: 'https://www.vrbo.com/',
    },
    {
      label: 'vacation-rentals',
      title: 'Vacation rentals',
      text: 'Search vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals',
    },
    {
      label: 'staycations',
      title: 'Staycations (road trips)',
      text: 'Find a great road trip on Vrbo',
      url: 'https://www.vrbo.com/travel/staycation',
    },
    {
      label: 'florida',
      title: 'Florida',
      text: 'Find Florida vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals/usa/florida',
    },
    {
      label: 'destin',
      title: 'Destin',
      text: 'Find Destin vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals/usa/florida/north-west/destin',
    },
    {
      label: 'panama-city-beach',
      title: 'Panama City Beach',
      text: 'Find Panama City Beach vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals/usa/florida/north-west/panama-city-beach',
    },
    {
      label: 'gulf-shores',
      title: 'Gulf Shores',
      text: 'Find Gulf Shores vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals/usa/alabama/gulf-shores',
    },
    {
      label: 'hilton-head-island',
      title: 'Hilton Head Island',
      text: 'Find Hilton Head Island vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals/usa/south-carolina/hilton-head-island',
    },
    {
      label: 'gatlinburg',
      title: 'Gatlinburg',
      text: 'Find Gatlinburg vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals/usa/tennessee/east/gatlinburg',
    },
    {
      label: 'key-west',
      title: 'Key West',
      text: 'Find Key West vacation rentals on Vrbo',
      url: 'https://www.vrbo.com/vacation-rentals/usa/florida/keys/key-west-area/key-west',
    },
  ],
};

export { preConfiguredQuicklinks };
